import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matthias de Baat
 * id 8EF4AC1A-24B5-42C7-9D6B-5F35227788E4
 * name arrow-oscillating
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-oscillating.svg
 * tags
 * - Home Automation 
 */
export const ArrowOscillatingIcon = createSvgIcon(<><path d="M6 14H9L5 18L1 14H4C4 11.3 5.7 6.6 11 6.1V8.1C7.6 8.6 6 11.9 6 14M20 14C20 11.3 18.3 6.6 13 6.1V8.1C16.4 8.7 18 11.9 18 14H15L19 18L23 14H20Z" /></>, 'ArrowOscillatingIcon');
export default ArrowOscillatingIcon